module.exports = __webpack_public_path__ + "static/auditor-agg-1-f730d1a56432289e5368de04d4a87398.jpg";